import { ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';
import { useRecoilValue, useResetRecoilState } from 'recoil';

import { useCustomerActions } from '../../../../../store/customer/actions';
import { useProductActions } from '../../../../../store/product/actions';
import {
  directTreasuryOffersOperationTypeState,
  directTreasuryRescueOffersParamsState,
  equityOffersOperationTypeState,
  equityPositionOffersParamsState,
  fixedIncomeOffersOperationTypeState,
} from '../../../../../store/product/atom';
import { hasProductItem } from '../../../../../store/product/selectors';
import { customerCaptions, tableParse } from '../constants';
import { TableResponsiveItemProps } from '../models';

import { DesktopTableItem } from './desktop';
import { MobileTableItem } from './mobile';
import { TabletTableItem } from './tablet';

const TableItemBase = (props: TableResponsiveItemProps) => {
  const item = tableParse(props.itemData);

  const backgroundColorBadge =
    `risk.${item.suitabilityProfileName.toLocaleLowerCase()}` as ColorTypes.Option;

  const customerCaption = customerCaptions(item);

  const hasProduct = useRecoilValue(hasProductItem);
  const resetEquityPositionOffersParams = useResetRecoilState(equityPositionOffersParamsState);
  const resetDirectTreasuryRescueOffersParams = useResetRecoilState(
    directTreasuryRescueOffersParamsState
  );
  const resetDirectTreasuryOffersOperation = useResetRecoilState(
    directTreasuryOffersOperationTypeState
  );
  const resetEquityOffersOperation = useResetRecoilState(equityOffersOperationTypeState);
  const resetFixedIncomeOffersOperation = useResetRecoilState(fixedIncomeOffersOperationTypeState);

  const { handleSelectCustomerItem, updateCustomerStatus } = useCustomerActions();
  const { updateProductStatus, resetProduct } = useProductActions();

  const handleSelectCustomer = () => {
    const customer = props.itemData;

    updateProductStatus({
      label: hasProduct ? 'Produto selecionado' : 'Selecione o produto',
      status: hasProduct ? 'completed' : 'opened',
    });
    updateCustomerStatus({ label: 'Cliente selecionado', status: 'completed' });

    handleSelectCustomerItem(customer);
    props.handleClearSearch && props.handleClearSearch();

    if (hasProduct) {
      resetEquityPositionOffersParams();
      resetDirectTreasuryRescueOffersParams();
      resetProduct();
      resetDirectTreasuryOffersOperation();
      resetEquityOffersOperation();
      resetFixedIncomeOffersOperation();
      updateProductStatus({
        label: 'Selecione o produto',
        status: 'opened',
      });
    }
  };

  const tableItemProps = { item, customerCaption, backgroundColorBadge, handleSelectCustomer };

  const responsiveTableItem = useBreakpointValue({
    base: <MobileTableItem {...tableItemProps} />,
    sm: <TabletTableItem {...tableItemProps} />,
    lg: <DesktopTableItem {...tableItemProps} />,
  });

  return responsiveTableItem;
};

export const TableItem = React.memo(TableItemBase);
